import { render, staticRenderFns } from "./DadosGeraisPrestador.vue?vue&type=template&id=775b6e8c&scoped=true"
import script from "./DadosGeraisPrestador.vue?vue&type=script&lang=js"
export * from "./DadosGeraisPrestador.vue?vue&type=script&lang=js"
import style0 from "./DadosGeraisPrestador.vue?vue&type=style&index=0&id=775b6e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775b6e8c",
  null
  
)

export default component.exports